import { render, staticRenderFns } from "./OversizedModal.vue?vue&type=template&id=7104b7f7&scoped=true&"
import script from "./OversizedModal.vue?vue&type=script&lang=ts&"
export * from "./OversizedModal.vue?vue&type=script&lang=ts&"
import style0 from "./OversizedModal.vue?vue&type=style&index=0&id=7104b7f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104b7f7",
  null
  
)

export default component.exports